'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$scope', '$routeParams', '$window', 'OperatorService',
    function ($scope, $routeParams, $window, OperatorService) {
        $scope.operators = [];
        OperatorService.api.numeric(null, (data) => $scope.operators = data._embedded);
    }];
